import { apiPostForm } from "./http";
import { getApiErrorMessage, isApiError } from "./errors";

/** 资讯正文等：租户视频走 OSS `fanhub/tenants/{id}/news-videos/...` */
export async function uploadTenantVideoFile(file: File, tenantLegacyId: string): Promise<string> {
  const tid = tenantLegacyId.trim();
  if (!tid) throw new Error("缺少租户 ID");
  const fd = new FormData();
  fd.append("file", file);
  try {
    const r = await apiPostForm<{ url: string }>(`/api/tenants/${encodeURIComponent(tid)}/storage/upload-video`, fd);
    return r.url;
  } catch (e) {
    const raw = getApiErrorMessage(e);
    if (
      (isApiError(e) && e.status === 503) ||
      raw.includes("OSS 未配置") ||
      raw.includes("503")
    ) {
      throw new Error("视频存储未就绪：请配置对象存储（OSS）后重试，或联系管理员。");
    }
    throw e instanceof Error ? e : new Error(raw || "视频上传失败");
  }
}
